export default __webpack_public_path__ + "static/header_image_two-8841495c8b55d3b7908914dddbad8005.jpg";